import React from 'react';
import './index.css';
import hclogo from './hclogo.png';
import { ScreenContainer } from './screencontainer.js';
import { v4 as uuidv4 } from 'uuid';

class App extends React.Component {
  constructor( props ) {
    super( props );
    this.state = { urlAPI: '', urlAPI_QA:  ''};
    this.sessionID = uuidv4();
  }

  componentDidMount() {
    fetch(process.env.PUBLIC_URL + '/config.json',{headers: {'Content-Type': 'application/json; charset=utf-8'}})
  .then(response => response.json())
  .then(data => {
    this.setState({ urlAPI: data.REACT_APP_SVC_ENDPOINT, urlAPI_QA: data.REACT_APP_SVC_ENDPOINT_SECOND});
  })
  .catch(err => console.log(err));
  }

  render() {
    return(
      <>
        <img alt="logo" className='LogoProperties' src={ hclogo }/>
        <hr></hr>
        <ScreenContainer sessionID={this.sessionID} apiURLs={{apiURL:this.state.urlAPI, apiURL_QA:this.state.urlAPI_QA}}/>
      </>
    );
  }
}

export default App;

